import { render, staticRenderFns } from "./article-carousel.vue?vue&type=template&id=6e3147c0&scoped=true&lang=pug&"
import script from "./article-carousel.vue?vue&type=script&lang=coffee&"
export * from "./article-carousel.vue?vue&type=script&lang=coffee&"
import style0 from "./article-carousel.vue?vue&type=style&index=0&id=6e3147c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3147c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsBigArticleCard: require('/opt/build/repo/nuxt-app/components/globals/cards/big-article-card.vue').default,SsrCarousel: require('/opt/build/repo/node_modules/vue-ssr-carousel/index.js').default})
